import { render, staticRenderFns } from "./IntegrationDetail.vue?vue&type=template&id=53d8423d&scoped=true&"
import script from "./IntegrationDetail.vue?vue&type=script&lang=js&"
export * from "./IntegrationDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDetail.vue?vue&type=style&index=0&id=53d8423d&scoped=true&lang=css&"
import style1 from "./IntegrationDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8423d",
  null
  
)

export default component.exports